import { MediaLocation } from "@msdyn365-commerce/retail-proxy";

export function sortMediaLocations(a: MediaLocation, b: MediaLocation): number {
    if (a.IsAdditionalMedia !== b.IsAdditionalMedia) {
        return a.IsAdditionalMedia ? 1 : -1;
    }

    return (a.DisplayOrder ?? Infinity) - (b.DisplayOrder ?? Infinity);
}
